<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#vitamine2">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Vitamine și minerale</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black"></span></div>
    </div>

    <div id="vitamine2" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Sare</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.44 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.06 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina A</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">516 µg-RE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">74s µg-RE</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina D</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">23 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">3.25 µg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina E</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">10 mg TE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.5 mg TE</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina K</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">46 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">6.6 µg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina C</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">99 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">14 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Tiamină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.29 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.04 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Riboflavină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1.6 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.23 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B6</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.452 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.065 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Folat</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">90 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">13 µg</span></div>
      </div>


      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B12</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">2.2 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.32 µg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Biotină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">11 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.6 µg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid pantotenic</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">4.22 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.606 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Sodiu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">178 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">25.5 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Potasiu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">696 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">100 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Clorură</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">355 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">51 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Calciu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">837 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">120 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fosfor</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">459 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">66 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Magneziu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">68 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">9.7 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fier</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">9.1 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.3 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Zinc</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">2.7 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.39 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Iod</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">109 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">16 µg</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vitamine",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
